import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {
  ApiPaginationResult,
  ApiResult,
} from '../../shared/models/api-result.model';
import { CreateVariationAttribute, UpdateVariationAttribute } from '../models/variation-attribute.model';

@Injectable({
  providedIn: 'root',
})
export class VariationAttributeService {
  private http = inject(HttpClient);

  apiBaseUrl = environment.apiBaseUrl;

  getAll(
    pageNumber: number,
    pageSize: number,
    name?: string,
    description?: string
  ) {
    let params = '';

    if (name) params += `&name=${name}`;
    if (description) params += `&description=${description}`;

    return this.http.get<ApiPaginationResult>(
      this.apiBaseUrl +
        `/api/v1/variation-attributes?pageNumber=${pageNumber}&pageSize=${pageSize}${params}`
    );
  }

  getById(id: string) {
    return this.http.get<ApiResult>(
      this.apiBaseUrl + '/api/v1/variation-attributes/' + id
    );
  }

  getAllDropdown() {
    return this.http.get<ApiResult>(
      this.apiBaseUrl + `/api/v1/variation-attributes/dropdown`
    );
  }

  create(data: CreateVariationAttribute) {
    return this.http.post<ApiResult>(
      this.apiBaseUrl + '/api/v1/variation-attributes',
      data
    );
  }

  update(id: string, data: UpdateVariationAttribute) {
    return this.http.put<ApiResult>(
      this.apiBaseUrl + '/api/v1/variation-attributes/' + id,
      data
    );
  }

  updateStatus(id: string, isActive: boolean) {
    return this.http.patch<ApiResult>(
      this.apiBaseUrl + `/api/v1/variation-attributes/${id}/status`,
      { isActive }
    );
  }
}
